module.exports = __webpack_public_path__ + "fonts/fa-regular-400.f6c6f6c8.ttf";